import type { LegacyAnswers } from '../../../orders/components/new-order/configure-equipment/useLegacyQuestionnaire';
import type { SelectedItem } from '../../../orders/pages/newOrderFlow/configureEquipmentMockup/flow';
import type {
  Answers,
  ModelChoices,
} from '../../../orders/pages/newOrderFlow/configureEquipmentMockup/types';

export type PatientEquipmentConfiguration = {
  flow: 'new' | 'legacy';
  answers: Answers | LegacyAnswers;
  models: ModelChoices;
  items: SelectedItem[];
  complete: boolean;
};

/** A revisão mostra o equipamento principal uma vez e soma os adicionais repetidos. */
export const groupReviewExtras = (items: SelectedItem[], mainCode: string) => {
  const grouped = new Map<string, SelectedItem>();
  items.forEach((item) => {
    const code = item.sapCode.trim();
    if (!code || code === mainCode.trim()) return;
    const previous = grouped.get(code);
    grouped.set(code, {
      ...item,
      quantity: (previous?.quantity ?? 0) + (item.quantity ?? 1),
    });
  });
  return Array.from(grouped.values());
};
